import { render, staticRenderFns } from "./Bento.html?vue&type=template&id=228b33f5&"
import script from "./Bento.vue?vue&type=script&lang=js&"
export * from "./Bento.vue?vue&type=script&lang=js&"
import style0 from "./Bento.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports